import axiosInstance from './axiosInstance';

export const getAllDrivers = (params) => axiosInstance.get('/api/v1/drivers', { params });
export const getPendingDrivers = (params) => axiosInstance.get('/api/v1/drivers/admin/pending', { params });
export const approveDriver = (driverId) => axiosInstance.post(`/api/v1/drivers/${driverId}/approve`);
export const getDriverDocuments = (driverId) => axiosInstance.get(`/api/v1/admin/drivers/${driverId}/documents`);
export const reviewDocument = (docId, data) => axiosInstance.patch(`/api/v1/admin/documents/${docId}/review`, data);
// Admin uploading on a driver's behalf: the file goes up first (same endpoint the
// driver app uses), then the returned file_url is saved against the driver.
export const uploadDocumentFile = (file) => {
  const fd = new FormData();
  fd.append('file', file);
  return axiosInstance.post('/api/v1/upload/document', fd);
};
export const uploadDriverDocument = (driverId, data) =>
  axiosInstance.post(`/api/v1/admin/drivers/${driverId}/documents`, data);
